import React, { Component } from 'react'
import { getBoundingClientRect } from '../../utils/functions'
import { checkTranslation } from '../../utils/useful'
import FixedView from '../FixedView'
import TableHeadOptions from './TableHeadOptions'

class TableHead extends Component {

    state = {}

    componentWillUnmount() {
        window.removeEventListener("mousemove", this.mouseMove)
        window.removeEventListener("mouseup", this.mouseUp)
    }

    onMouseDown = (e, key) => {
        this.initWidth = getBoundingClientRect(this[key]).width
        this.initLeft = getBoundingClientRect(this[key]).left
        this.setState({ selectedKey: key, initX: e.clientX })
        window.addEventListener("mousemove", this.mouseMove)
        window.addEventListener("mouseup", this.mouseUp)
    }

    mouseMove = (e) => {
        let x = e.clientX
        // let width = getBoundingClientRect(this[this.state.selectedKey]).width
        let dx = x - this.state.initX
        if (Math.abs(this.state.initX - this.initLeft) < 20) {
            dx = dx * -1
        }
        let newWidth = this.initWidth + dx
        if (newWidth >= 100) {
            this.props.changeWidth(this.state.selectedKey, newWidth)
        }
    }

    openOptions = () => {
        this.dataOptionsList.showView()
    }

    mouseUp = (e) => {
        let tempWidth = {}
        tempWidth.tableWidth = { ...this.props.tempWidth }
        if (this.props.saveUserSettings) {
            this.props.saveUserSettings(tempWidth)
        }
        this.setState({ selectedKey: null })
        window.removeEventListener("mousemove", this.mouseMove)
        window.removeEventListener("mouseup", this.mouseUp)
    }

    render() {
        return (
            <div className={"flexc tableHeader " + (this.state.selectedKey ? 'isResizingTable' : '')} style={{ alignItems: 'stretch', display: 'flex' }}>
                {this.props.actions && (
                    <div ref={el => this[''] = el} className={"flexcc"} style={{ flex: '0 0', maxWidth: 30, flexBasis: 30, borderRight: "none", borderLeft: "none", width: 30 }}>
                        <img className='stage-action-button-img opacity-2' src={'/assets/icons/useful/action.png'} height={10} />
                    </div>
                )}
                {this.props.headers?.map((prop, index) => {
                    if (prop.showMain != false) {
                        let isSticky = false
                        if (index === 0 && Math.abs(this.props.scrollX) > 5) {
                            isSticky = true
                        }
                        // transform: isSticky ? 'translateX(' + this.props.scrollX + 'px)' : 'translateX(0px)',
                        if (this.props.maxIndex == null || index < this.props.maxIndex) {
                            return (
                                <div ref={el => this[prop.key] = el} className={"flexc flex-row tableHeaderItem  " + (index == 0 ? ' firstTableHeaderItem ' : '') + (isSticky ? 'stickyTableHeaderItem' : '')} key={prop.key} style={{ flex: index == 0 ? '0 0' : '0 0', maxWidth: index == 0 ? null : this.props.widths[prop.key], flexBasis: this.props.widths[prop.key] }}>
                                    {/* <div ref={e => this['imgOption-' + index] = e}>
                                        <img className='stage-action-button-img' src='/assets/icons/useful/action.png' height={10} style={{ cursor: 'pointer' }} onClick={() => this.openOptions()} />
                                    </div> */}
                                    {/* {index == 0 && (
                                        <div className='' style={{}}>
                                            {!this.props.settings?.extendedActions && this.props.actions && (
                                                <div ref={el => this[''] = el} className={"  "} style={{ flex: '0 0', maxWidth: 30, flexBasis: 30, borderRight: "none", borderLeft: "none", width: 30 }}>
                                                    <img className='stage-action-button-img opacity-2' src={'/assets/icons/useful/action.png'} height={10} />
                                                </div>
                                            )}
                                        </div>
                                    )} */}
                                    <p className="table-header-text" >{checkTranslation(prop.information?.label)}</p>
                                    {/* style={{whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}} */}
                                    <TableHeadOptions key={index} header={prop} handleCopy={this.props.handleCopy} setCurrentHead={this.props.setCurrentHead} currentHead={this.props.currentHead} fieldOptions={this.props.fieldOptions} duplicateField={this.props.duplicateField} sortFieldRecord={this.props.sortFieldRecord} insertField={this.props.insertField} hideHeaderField={this.props.hideHeaderField} deleteHeaderField={this.props.deleteHeaderField} groupByField={this.props.groupByField} functionsHandler={this.props.functionsHandler} />
                                    <div className={"resizer " + (this.state.selectedKey === prop.key ? 'activedResizer' : '')} onMouseDown={e => this.onMouseDown(e, prop.key)}></div>
                                </div>
                            )
                        }
                    }
                })}
                {/* {this.props.settings?.extendedActions && this.props.actions?.map((prop, index) => {
                    let isSticky = false
                    return (
                        <div ref={el => this["actions-" + prop.key] = el} className={"tableHeaderItem blur-back "} style={{ flex: '0 0', maxWidth: 120, flexBasis: 100 }}>
                            <span>{checkTranslation(prop.information?.label)}</span>
                            <div className={"resizer " + (this.state.selectedKey === prop.key ? 'activedResizer' : '')} onMouseDown={e => this.onMouseDown(e, prop.key)}></div>
                        </div>
                    )
                })} */}
                {/* {!this.props.settings?.extendedActions && this.props.actions && (
                    <div ref={el => this['action-actions'] = el} className={"tableHeaderItem  "} style={{ flex: '0 0', borderRight: "none", borderLeft: "none", maxWidth: this.props.widths['*actions'], flexBasis: this.props.widths['*actions'] }}>
                        <span>{checkTranslation("{{lang}}actions")}</span>
                    </div>
                )} */}
            </div>
        )
    }
}

export default TableHead